module.exports = __webpack_public_path__ + "static/media/step4.d734c375.svg";